import React from "react";
import { ArrowRight, Wrench } from "lucide-react";
import SEO from "@/components/SEO";
import Reveal from "@/components/Reveal";
import { PageHero, Section, PrimaryButton } from "@/components/ui-helpers";
import { EQUIPMENT } from "@/data/content";

export default function WhatWeUse() {
  return (
    <>
      <SEO title="What We Use" description="The professional equipment and products Ascendia uses: wet/dry extraction, steam, pressure washing, floor equipment, detailing brushes, microfiber systems and window tools." />
      <PageHero kicker="What We Use" title="Professional equipment, used properly" subtitle="Detailing takes more than a cloth and a spray bottle. Here's the professional kit behind the Ascendia Standard.">
        <PrimaryButton to="/contact">Request a Quote <ArrowRight className="h-4 w-4" /></PrimaryButton>
      </PageHero>
      <Section>
        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {EQUIPMENT.map((e, i) => (
            <Reveal key={e.t} delay={(i % 4) * 0.05}>
              <div className="ascendia-card card-accent-top p-6 h-full">
                <div className="flex h-11 w-11 items-center justify-center rounded-xl bg-gold/10 border border-[color:var(--border-subtle)]"><Wrench className="h-5 w-5 text-gold-soft" strokeWidth={1.5} /></div>
                <h3 className="mt-4 font-display text-base font-semibold text-white u-tracking-tight">{e.t}</h3>
                <p className="mt-2 text-sm text-secondary u-body">{e.d}</p>
              </div>
            </Reveal>
          ))}
        </div>
        <p className="mt-8 text-sm text-muted-c">We select surface-appropriate products and methods after identifying each material — we won't use anything that risks damaging your surfaces.</p>
      </Section>
    </>
  );
}
